import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import GiftBoxFragment from './fragments/GiftBoxFragment';
import GiftCategoryFragment from './fragments/GiftCategoryFragment';
import GiftMainFragment from './fragments/GiftMainFragment';

interface Params {
    type: 'MAIN' | 'CATEGORY' | 'BOX';
}

const GiftsActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { type } = params;
    const { stepReplace } = useStepFlow('GiftsActivity');
    const { t } = useTranslation('gift');
    return (
        <AppScreen>
            <Header title={t('title')} />
            <TabList variant='solid'>
                <TabItem selected={type === 'MAIN'}
                    onClick={() => stepReplace({ type: 'MAIN' })} >
                    {t('tabs.main')}
                </TabItem>
                <TabItem selected={type === 'CATEGORY'}
                    onClick={() => stepReplace({ type: 'CATEGORY' })} >
                    {t('tabs.category')}
                </TabItem>
                <TabItem selected={type === 'BOX'}
                    onClick={() => stepReplace({ type: 'BOX' })} >
                    {t('tabs.box')}
                </TabItem>
            </TabList>
            {type === 'MAIN' && (
                <GiftMainFragment/>
            )}
            {type === 'CATEGORY' && (
                <GiftCategoryFragment/>
            )}
            {type === 'BOX' && (
                <GiftBoxFragment/>
            )}
        </AppScreen>
    );
};

export default GiftsActivity;
